
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.494 9.53a1 1 0 00.314 1.627l2.033.871a.302.302 0 00.398-.166C6.687 10.752 7.15 9.8 7.625 9 8.08 8.24 8.68 7.4 9.43 6.486a.303.303 0 00-.17-.49l-.809-.17a1.93 1.93 0 00-.975.05c-.317.1-.592.266-.825.5L3.494 9.53zm4.176 3.032a.49.49 0 00.119.503l3.47 3.493a.49.49 0 00.506.121 15.236 15.236 0 003.135-1.49 16.804 16.804 0 003-2.389 14.17 14.17 0 003.275-5.025c.616-1.618.862-3.143.74-4.577a.863.863 0 00-.788-.788c-1.434-.121-2.96.13-4.577.752a14.326 14.326 0 00-5.025 3.288 16.503 16.503 0 00-2.388 3 15.328 15.328 0 00-1.467 3.112zm6.805-2.712a1.92 1.92 0 01-.575-1.413c0-.558.192-1.029.575-1.412a1.921 1.921 0 011.413-.575 1.92 1.92 0 011.412.575c.383.383.575.854.575 1.412A1.92 1.92 0 0117.3 9.85a1.92 1.92 0 01-1.412.575c-.559 0-1.03-.192-1.413-.575zm-1.286 10.68a1 1 0 001.624.307L17.95 17.7c.233-.233.4-.512.5-.837.1-.325.117-.655.05-.988l-.153-.797a.304.304 0 00-.49-.176c-.914.747-1.753 1.346-2.519 1.798-.806.476-1.764.938-2.873 1.385a.302.302 0 00-.166.4l.89 2.044zM4.05 16.05a2.938 2.938 0 012.125-.888 2.852 2.852 0 012.125.863c.583.583.875 1.292.875 2.125s-.292 1.542-.875 2.125c-.417.417-1.112.775-2.087 1.075-.714.22-1.626.421-2.738.605A.96.96 0 012.37 20.85c.184-1.11.386-2.018.605-2.725.3-.967.658-1.658 1.075-2.075z","fill":"#fff"}})])
          )
        }
      }
    